import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    computed: {
        ...mapGetters('zone', ['zones']),
    },

    methods: {
        ...mapActions('zone', ['getZoneListIfNecessary']),

        refreshZoneList: _.debounce(function(query) {
            this.getZoneListIfNecessary({ query: query });
        }, 500),
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/zone.js